import { useSelector } from '@/api/state';
import { Field, Select } from '@payaca/ambrosia';

import { FormTaskValues } from '@/ui/components/createEditTaskSidebar/types';
import { sortedAvailableFormOptions } from '@payaca/helpers/formHelper';
import * as formActions from '@payaca/store/forms/formsActions';
import { FormOptionGroups } from '@payaca/types/formTypes';
import { FC, useEffect, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

export type { FormTaskValues };

const FormTaskFieldset: FC<{
  isEditing: boolean;
}> = (props) => {
  const { isEditing } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    // get available forms
    dispatch(formActions.requestGetAvailableForms());
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, []);

  const availableForms = useSelector((state) => state.forms.availableForms);

  const availableFormOptions = useMemo(
    () =>
      availableForms &&
      sortedAvailableFormOptions(
        availableForms.filter((form) => form.type !== 'pdf')
      ),
    [availableForms]
  );

  /**
   * react hook form
   */
  const { control } = useFormContext<FormTaskValues>();

  return (
    <>
      <Controller
        name="formId"
        control={control}
        shouldUnregister
        render={({ field: { value, onChange, name } }) => {
          return (
            <Field name={name}>
              <Field.Label>Form</Field.Label>

              <Select
                disabled={isEditing}
                multiple={false}
                value={value}
                onChange={onChange}
                options={availableFormOptions.map((i) => ({
                  label: i.label,
                  value: i.value,
                  groupId: i.optionGroupId.toString(),
                }))}
                optionGroups={FormOptionGroups.map((i) => ({
                  id: i.id.toString(),
                  label: i.name,
                }))}
              />
            </Field>
          );
        }}
      />
    </>
  );
};

export default FormTaskFieldset;
